export default __webpack_public_path__ + "static/me_and_don_beach-aa309de37ca71d0a164063fe76862530.jpg";